module.exports = __webpack_public_path__ + "static/media/bl.11ef8840.svg";